import { styled } from '@withjoy/joykit';

export const VIPDescription = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 0.75rem 1rem;
  outline: 1px solid var(--gray8, #e1e1e1);
  border: none;
  transition:
    border-color 500ms cubic-bezier(0.23, 1, 0.32, 1) 0s,
    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1) 0s;
  box-shadow: 0px 0 0px 2px transparent;
  box-sizing: border-box;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.375rem;
  resize: none;
  font-family: inherit;

  &:focus {
    outline: none;
    box-shadow: 0px 0 0px 2px #333333;
  }

  &::placeholder {
    color: var(--gray11, #6b7280);
  }
`;
